import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Card,
    CircularProgress,
    Fade,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import Rating from '@mui/material/Rating';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import { compareAsc, format, isPast } from 'date-fns';
import addDays from 'date-fns/addDays';
import enLocale from 'date-fns/locale/en-AU';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, useHistory, useRouteMatch } from 'react-router-dom';
import TitleCase from '../components/BasicComponents/TitleCase';
import QuickBook from '../components/BookingInfo/QuickBook';
import Loading from '../components/Loading';
import Title from '../components/Navbar/Title';
import SimpleSnackbar from '../components/SnackBar/SimpleSnackbar';
import sendNotification from '../utils/sendNotification';
import { resetAddBookingStatus } from '../redux/BookingSlice';
import { fetchSchool } from '../redux/SchoolSlice';
import { grades } from '../utils/grades';
import CreateBooking from '../views/CreateBooking';
import logoAlone from '../assets/airTeachr-Logo-alone.png';

function Alert(props) {
    return <MuiAlert elevation={6} {...props} />;
}

const daysForQuicBook = 5;

const CustomFormControl = styled(FormControl)(({ theme }) => ({
    minWidth: '180px',
    margin: theme.spacing(1),
    backgroundColor: '#fff',
    textAlign: 'left',
}));

const BookingFormBox = styled(Box)(({ theme }) => ({
    margin: '20px auto 0',
    width: '100%',
    textAlign: 'center',
}));

const BookingButton = styled(Button)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

const AvailableTeachersBox = styled(Box)(({ theme }) => ({
    backgroundColor: '#FAFBFB',
    width: '100%',
    padding: '20px',
}));

const AvailableTeachersTitleType = styled(Typography)(({ theme }) => ({
    width: '100%',
    padding: '20px',
    textTransform: 'none',
}));

const TeacherResultsContainerBox = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridGap: '20px',
    gridRowGap: 0,
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 300px))',
    justifyContent: 'center',
    alignItems: 'center',
}));

const TeacherResultsCard = styled(Card)(({ theme }) => ({
    width: '100%',
    margin: '20px auto',
    padding: '20px',
    boxShadow: '1px 1px 9px -2px rgb(0 0 0 / 20%)',
    borderRadius: '10px',
    '&:hover, &:focus, &:active': {
        position: 'relative',
        top: '-5px',
        cursor: 'pointer',
        border: `1px solid ${theme.palette.primary.main}`,
    },
}));

const TeacherImgContainer = styled('div')(({ theme }) => ({
    margin: 'auto',
    width: '100%',
    textAlign: 'center',
}));

const TeacherImg = styled('img')(({ theme }) => ({
    width: '100%',
    height: 'auto',
    borderRadius: '10px',
}));

const TeacherInfoType = styled(Typography)(({ theme }) => ({
    padding: '10px 4px 0',
}));

const BoxMobile = styled(Box)(({ theme }) => ({
    margin: '20px',
    [theme.breakpoints.up('sm')]: {
        display: 'none',
    },
}));

const BoxDesktop = styled(Box)(({ theme }) => ({
    margin: '20px',
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));

const SavedIcon = () => {
    return (
        <Grid item align="right">
            <Grid container>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }} p={0.5}>
                    Saved
                </Typography>
                <img src={logoAlone} width="40" />
            </Grid>
        </Grid>
    );
};

const validPermission = 'create:booking';

// const match = matchPath('/book-teacher/availability/123', {
//     path: '/book-teacher/availability/:id',
//     exact: true,
//     strict: false,
// });

export const BookTeacherComponent = () => {
    const { getAccessTokenSilently } = useAuth0();
    //const classes = useStyles();
    let match = useRouteMatch();

    const { profile } = useSelector(state => state.profile);
    const { token } = useSelector(state => state.token);
    const profileStatus = useSelector(state => state.profile.status);
    const tokenStatus = useSelector(state => state.token.status);
    const schoolStatus = useSelector(state => state.school.status);
    const schoolInfo = useSelector(state => state.school);

    const dispatch = useDispatch();
    const [state, setState] = useState({
        yearLevel: '',
        searchSize: 30,
        redirectToHome: false,
        availability: { responseVals: [] },
        selectTeacher: 0,
        apiState: 0,
        loading: false,
        dateError: false,
        snackOpen: false,
        helperText: '',
        date: new Date().setHours(12, 0, 0, 0),
    });
    const [savedOnly, setSavedOnly] = useState(false);

    const [expanded, setExpanded] = useState('panel1');
    const [quickBookComplete, setQuickBookComplete] = useState(false);

    useEffect(() => {
        //useEffect is completed on page load
        //Service to get the profile for a user
        console.log(
            'status of profile ' + profileStatus + ' ' + profile.Data.Count
        );
        // if (profileStatus === 'idle') {
        //     async function dispatchProfileFromStore() {
        //         const token = await getAccessTokenSilently({
        //             scope: process.env.REACT_APP_scope,
        //         });

        //         dispatch(storeToken(token));
        //         dispatch(fetchProfile(token));
        //     }
        //     dispatchProfileFromStore();
        // }
        if (profileStatus === 'succeeded' && profile.Data.Count === 0) {
            setState({
                ...state,
                redirectToHome: true,
            });
        }

        //Enhance to check the token rights instead of the database + this code is in Profile too (Update there also)
        if (profileStatus === 'succeeded' && profile.Data.Count > 0) {
            if (profile.Data.Items[0].type === 'School') {
                async function dispatchSchoolFromStore() {
                    const token = await getAccessTokenSilently({
                        scope: process.env.REACT_APP_scope,
                    });
                    const requestData = {
                        'token': token,
                        'schoolId': profile.Data.Items[0]['gs1-pk'],
                    };
                    dispatch(fetchSchool(requestData));
                }
                dispatchSchoolFromStore();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getAccessTokenSilently, profileStatus, dispatch]);

    useEffect(() => {
        if (tokenStatus === 'succeeded' && token.Count === 1) {
            if (token.permissions.includes(validPermission) === false)
                setState({
                    ...state,
                    redirectToHome: true,
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenStatus, token.Count, token.permissions]);

    const handleDateChange = date => {
        console.log('date', date);
        // Can't book same day after 10
        date.setHours(12, 0, 0, 0);
        setState({
            ...state,
            date: date,
            dateError: false,
            helperText: '',
        });
    };

    const handleGradeChange = event => {
        setState({
            ...state,
            yearLevel: event.target.value,
        });
    };

    const handleSizeChange = event => {
        setState({
            ...state,
            searchSize: event.target.value,
        });
    };

    const resetSearch = () => {
        // console.log('called reset search');
        // dispatch(resetAddBookingStatus());
        setState({
            ...state,
            availability: { responseVals: [] },
            apiState: 0,
            selectTeacher: 0,
            loading: false,
        });
    };

    const removeAvail = async id => {
        //var interimState = state.availability;
        const interimState = state.availability.responseVals.filter(
            avail => avail.uniqueId !== id
        );
        // interimState.responseVals[index].booked = 'done';
        // console.log(JSON.stringify(interimState.responseVals), index);
        setState({
            ...state,
            availability: { responseVals: interimState },
        });
    };

    const isSaved = (school, teacher) => {
        console.log('isSaved');
        const id = teacher.teacherUniqueId;
        if (id === undefined || school.school.Data.crtList === undefined)
            return false;
        for (const teacher of school.school.Data.crtList) {
            if (teacher.uniqueId === id) {
                return true;
            }
        }
        return false;
    };
    const searchTeachers = async getTeacherParams => {
        dispatch(resetAddBookingStatus());
        setState({
            ...state,
            loading: true,
            dateError: false,
            helperText: '',
        });

        console.log('Is there a schoolInfo: ' + JSON.stringify(schoolInfo));
        const token = await getAccessTokenSilently({
            scope: process.env.REACT_APP_scope,
        });

        let response = await axios
            .get('/searchTeachers', {
                params: getTeacherParams,
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: `/searchTeachers`,
                timeout: 30000,
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + token,
                },
            })
            .catch(err => setState({ ...state, loading: false }));

        if (response.data.count > 0) {
            setExpanded('');
        }
        //cycle to set with rating
        const sortedResults = response.data.responseVals.sort(
            // sortAvails(false)
            (a, b) => b.rating - a.rating
        );

        //Mark saved teachers
        for (const teacher of sortedResults) {
            teacher.saved = isSaved(schoolInfo, teacher);
            console.log('isSaved ', isSaved(schoolInfo, teacher));
        }

        setState({
            ...state,
            availability: {
                responseVals: sortedResults,
            },
            date: new Date(getTeacherParams.date),
            apiState: response.status,
            loading: false,
            dateError: false,
            helperText: '',
            searchDate: new Date(getTeacherParams.date),
        });
        setQuickBookComplete(false);
    };

    const setSearchDate = async (searchDate, searchYear, searchSize) => {
        console.log('startedSearch-' + state.date);

        if (
            typeof searchDate !== 'undefined' &&
            typeof searchYear !== 'undefined' &&
            typeof searchSize !== 'undefined' &&
            typeof schoolInfo.school.Data.lat !== 'undefined' &&
            typeof schoolInfo.school.Data.lng !== 'undefined'
        ) {
            let getTeacherParams = {
                lat: schoolInfo.school.Data.lat,
                lng: schoolInfo.school.Data.lng,
                date: format(searchDate, 'yyyy/MM/dd'),
                id: schoolInfo.school.Data.pk1,
                length: searchSize,
            };

            if (searchYear !== '' && searchYear !== 'All')
                getTeacherParams.grades = searchYear;

            searchTeachers(getTeacherParams);
        } else if (
            typeof state.date === 'undefined' ||
            typeof schoolInfo.school.Data.lat === 'undefined' ||
            typeof schoolInfo.school.Data.lng === 'undefined'
        ) {
            setState({
                ...state,
                loading: false,
                dateError: true,
                helperText: 'Please select a date',
            });
        } else if (isPast(state.date)) {
            setState({
                ...state,
                loading: false,
                dateError: true,
                helperText: 'Please pick future date',
            });
        } else {
            let getTeacherParams = {
                lat: schoolInfo.school.Data.lat,
                lng: schoolInfo.school.Data.lng,
                date: format(state.date, 'yyyy/MM/dd'),
                id: schoolInfo.school.Data.pk1,
                length: state.searchSize,
            };

            if (state.yearLevel !== '' && state.yearLevel !== 'All')
                getTeacherParams.grades = state.yearLevel;

            searchTeachers(getTeacherParams);
        }
    };

    // put outside to use for card links
    let history = useHistory();

    const handleAccordionChange = panel => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    let content;

    if (state.redirectToHome === true) {
        content = <Redirect to="/home" />;
    } else {
        content = (
            <div>
                <Title title="Book a Teacher" />
                <Grid
                    container
                    xs={12}
                    directon="row"
                    justifyContent="space-around"
                    alignItems="stretch"
                    spacing={0}
                >
                    <Route path="/book-teacher" exact>
                        {schoolStatus === 'succeeded' ? (
                            <Box sx={{ width: '100%' }}>
                                {/* {typeof schoolInfo.school.Data.planStatus !==
                                'undefined' ? ( */}
                                <Box>
                                    {/* {schoolInfo.school.Data.planStatus ===
                                        'Active' ? ( */}
                                    <Grid
                                        container
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: '20px',
                                        }}
                                    >
                                        <Grid item xs={10}>
                                            <Accordion
                                                expanded={expanded === 'panel1'}
                                                onChange={handleAccordionChange(
                                                    'panel1'
                                                )}
                                                sx={{ width: '100%' }}
                                            >
                                                <AccordionSummary
                                                    expandIcon={
                                                        <ExpandMoreIcon />
                                                    }
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                    sx={{
                                                        width: '100%',
                                                    }}
                                                >
                                                    <Typography
                                                        variant="h5"
                                                        align="center"
                                                    >
                                                        Date Search
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails
                                                    sx={{
                                                        width: '100%',
                                                    }}
                                                >
                                                    <BookingFormBox>
                                                        <form>
                                                            <BoxMobile>
                                                                <LocalizationProvider
                                                                    dateAdapter={
                                                                        AdapterDateFns
                                                                    }
                                                                    locale={
                                                                        enLocale
                                                                    }
                                                                >
                                                                    <MobileDatePicker
                                                                        id="date"
                                                                        label="Date"
                                                                        value={
                                                                            state.date
                                                                        }
                                                                        onChange={newValue =>
                                                                            handleDateChange(
                                                                                newValue
                                                                            )
                                                                        }
                                                                        disablePast={
                                                                            true
                                                                        }
                                                                        renderInput={params => (
                                                                            <TextField
                                                                                {...params}
                                                                                error={
                                                                                    state.dateError
                                                                                }
                                                                                helperText={
                                                                                    state.dateError
                                                                                        ? 'Please enter a date to search'
                                                                                        : ''
                                                                                }
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                            </BoxMobile>
                                                            <BoxDesktop>
                                                                <LocalizationProvider
                                                                    dateAdapter={
                                                                        AdapterDateFns
                                                                    }
                                                                    locale={
                                                                        enLocale
                                                                    }
                                                                >
                                                                    <DesktopDatePicker
                                                                        id="date"
                                                                        label="For desktop"
                                                                        value={
                                                                            state.date
                                                                        }
                                                                        onChange={newValue =>
                                                                            handleDateChange(
                                                                                newValue
                                                                            )
                                                                        }
                                                                        disablePast={
                                                                            true
                                                                        }
                                                                        renderInput={params => (
                                                                            <TextField
                                                                                {...params}
                                                                                error={
                                                                                    state.dateError
                                                                                }
                                                                                helperText={
                                                                                    state.helperText
                                                                                }
                                                                            />
                                                                        )}
                                                                    />
                                                                </LocalizationProvider>
                                                            </BoxDesktop>
                                                            <Box>
                                                                <CustomFormControl variant="outlined">
                                                                    <InputLabel id="demo-simple-select-outlined-label">
                                                                        Year
                                                                        Level
                                                                    </InputLabel>
                                                                    <Select
                                                                        data-cy="select-grade"
                                                                        labelId="demo-simple-select-outlined-label"
                                                                        id="yearLevel"
                                                                        value={
                                                                            state.yearLevel
                                                                        }
                                                                        onChange={
                                                                            handleGradeChange
                                                                        }
                                                                        label="Choose a Level"
                                                                    >
                                                                        {grades.map(
                                                                            (
                                                                                menuItem,
                                                                                index
                                                                            ) => (
                                                                                <MenuItem
                                                                                    id={
                                                                                        index
                                                                                    }
                                                                                    value={
                                                                                        menuItem.name
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        menuItem.title
                                                                                    }
                                                                                </MenuItem>
                                                                            )
                                                                        )}
                                                                        <MenuItem
                                                                            id={
                                                                                5
                                                                            }
                                                                            value="All"
                                                                        >
                                                                            All
                                                                        </MenuItem>
                                                                    </Select>
                                                                </CustomFormControl>
                                                            </Box>
                                                            <Box>
                                                                <CustomFormControl variant="outlined">
                                                                    <InputLabel id="demo-simple-select-outlined-label">
                                                                        Search
                                                                        Size
                                                                    </InputLabel>
                                                                    <Select
                                                                        data-cy="select-radius"
                                                                        labelId="demo-simple-select-outlined-label"
                                                                        id="searchSize"
                                                                        value={
                                                                            state.searchSize
                                                                        }
                                                                        onChange={
                                                                            handleSizeChange
                                                                        }
                                                                        label="Choose a search size"
                                                                    >
                                                                        <MenuItem
                                                                            id={
                                                                                1
                                                                            }
                                                                            value="30"
                                                                        >
                                                                            15km
                                                                        </MenuItem>
                                                                        <MenuItem
                                                                            id={
                                                                                2
                                                                            }
                                                                            value="50"
                                                                        >
                                                                            35km
                                                                        </MenuItem>
                                                                        <MenuItem
                                                                            id={
                                                                                3
                                                                            }
                                                                            value="70"
                                                                        >
                                                                            50km
                                                                        </MenuItem>
                                                                    </Select>
                                                                </CustomFormControl>
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    margin: '20px',
                                                                }}
                                                            >
                                                                {state.loading ? (
                                                                    <Fade
                                                                        in={
                                                                            state.loading
                                                                        }
                                                                        style={{
                                                                            transitionDelay:
                                                                                state.loading
                                                                                    ? '400ms'
                                                                                    : '0ms',
                                                                        }}
                                                                        unmountOnExit
                                                                    >
                                                                        <CircularProgress />
                                                                    </Fade>
                                                                ) : (
                                                                    <Fade
                                                                        in={
                                                                            !state.loading
                                                                        }
                                                                        style={{
                                                                            transitionDelay:
                                                                                !state.loading
                                                                                    ? '200ms'
                                                                                    : '0ms',
                                                                        }}
                                                                    >
                                                                        <BookingButton
                                                                            variant="contained"
                                                                            size="large"
                                                                            color="primary"
                                                                            onClick={
                                                                                setSearchDate
                                                                            }
                                                                            startIcon={
                                                                                <SearchIcon />
                                                                            }
                                                                        >
                                                                            Search
                                                                        </BookingButton>
                                                                    </Fade>
                                                                )}
                                                            </Box>
                                                        </form>
                                                    </BookingFormBox>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                        {state.apiState !== 0 && (
                                            <Grid item xs={10}>
                                                <AvailableTeachersBox>
                                                    {state.availability
                                                        .responseVals.length >
                                                        0 &&
                                                        compareAsc(
                                                            state.searchDate,
                                                            addDays(
                                                                Date.now(),
                                                                daysForQuicBook
                                                            )
                                                        ) === -1 && (
                                                            <>
                                                                <QuickBook
                                                                    school={
                                                                        schoolInfo
                                                                    }
                                                                    avails={
                                                                        state
                                                                            .availability
                                                                            .responseVals
                                                                    }
                                                                    loadingAvails={
                                                                        state.loading
                                                                    }
                                                                    quickBookComplete={value => {
                                                                        setQuickBookComplete(
                                                                            value
                                                                        );
                                                                    }}
                                                                    date={
                                                                        state.date
                                                                    }
                                                                    onlyShowSaved={
                                                                        setSavedOnly
                                                                    }
                                                                ></QuickBook>
                                                            </>
                                                        )}
                                                    {typeof state.searchDate !==
                                                        'undefined' && (
                                                        <AvailableTeachersTitleType
                                                            variant="h5"
                                                            align="center"
                                                        >
                                                            {
                                                                state.availability.responseVals
                                                                    .filter(
                                                                        avail =>
                                                                            avail.booked !==
                                                                            'done'
                                                                    )
                                                                    .filter(
                                                                        avail =>
                                                                            avail.saved ||
                                                                            !savedOnly
                                                                    ).length
                                                            }
                                                            {state.availability.responseVals.filter(
                                                                avail =>
                                                                    !savedOnly ||
                                                                    avail.saved
                                                            ).length === 1
                                                                ? ' Teacher Available on '
                                                                : ' Teachers Available on '}
                                                            {format(
                                                                state.searchDate,
                                                                'do MMMM yyyy'
                                                            )}
                                                        </AvailableTeachersTitleType>
                                                    )}
                                                    {!quickBookComplete && (
                                                        <TeacherResultsContainerBox>
                                                            {state.availability.responseVals.map(
                                                                (
                                                                    item,
                                                                    index
                                                                ) => {
                                                                    if (
                                                                        typeof item.booked ===
                                                                            'undefined' &&
                                                                        (item.saved ||
                                                                            !savedOnly)
                                                                    ) {
                                                                        return (
                                                                            <TeacherResultsCard
                                                                                data-cy="teacherTile"
                                                                                onClick={() => {
                                                                                    history.push(
                                                                                        match.path +
                                                                                            `/availability/${item.uniqueId}` +
                                                                                            '?date=' +
                                                                                            format(
                                                                                                state.date,
                                                                                                'yyyy-MM-dd'
                                                                                            ) +
                                                                                            '&year=' +
                                                                                            state.yearLevel +
                                                                                            '&size=' +
                                                                                            state.searchSize
                                                                                    );
                                                                                }}
                                                                                key={
                                                                                    item.uniqueId
                                                                                }
                                                                            >
                                                                                <Grid
                                                                                    container
                                                                                    sx={{
                                                                                        display:
                                                                                            'flex',
                                                                                        justifyContent:
                                                                                            'space-between',
                                                                                    }}
                                                                                >
                                                                                    <Grid
                                                                                        item
                                                                                    >
                                                                                        <TitleCase
                                                                                            variant="h3"
                                                                                            string={
                                                                                                item.teacherFirstName
                                                                                            }
                                                                                            data-cy="teacherTileName"
                                                                                        />
                                                                                    </Grid>
                                                                                    {item.saved && (
                                                                                        <SavedIcon />
                                                                                    )}
                                                                                </Grid>
                                                                                {item.rating ? (
                                                                                    <Grid
                                                                                        container
                                                                                    >
                                                                                        <Grid
                                                                                            item
                                                                                            xs={
                                                                                                7
                                                                                            }
                                                                                            sm={
                                                                                                6
                                                                                            }
                                                                                        >
                                                                                            <Rating
                                                                                                name="simple-controlled"
                                                                                                value={
                                                                                                    item.rating
                                                                                                }
                                                                                                readOnly
                                                                                                precision={
                                                                                                    0.5
                                                                                                }
                                                                                            ></Rating>
                                                                                        </Grid>
                                                                                        <Grid
                                                                                            item
                                                                                            xs={
                                                                                                5
                                                                                            }
                                                                                            sm={
                                                                                                6
                                                                                            }
                                                                                        >
                                                                                            <Typography>
                                                                                                {`/ ${item.amountOfRatings} reviews`}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                ) : (
                                                                                    <Typography variant="body1">
                                                                                        No
                                                                                        Rating
                                                                                        Available
                                                                                    </Typography>
                                                                                )}

                                                                                <TeacherImgContainer>
                                                                                    <TeacherImg
                                                                                        src={
                                                                                            item.teacherProfile
                                                                                        }
                                                                                    />
                                                                                </TeacherImgContainer>
                                                                                <TeacherInfoType variant="body1">
                                                                                    {item.grades ===
                                                                                    undefined ? (
                                                                                        <Typography>
                                                                                            No
                                                                                            Allocated
                                                                                            Grades
                                                                                        </Typography>
                                                                                    ) : (
                                                                                        item.grades.map(
                                                                                            grade => {
                                                                                                return (
                                                                                                    <Typography>
                                                                                                        {
                                                                                                            grade
                                                                                                        }
                                                                                                    </Typography>
                                                                                                );
                                                                                            }
                                                                                        )
                                                                                    )}
                                                                                </TeacherInfoType>
                                                                                {/* <Linking
                                                                avail={index}
                                                            ></Linking> */}
                                                                            </TeacherResultsCard>
                                                                        );
                                                                    }
                                                                    return (
                                                                        <></>
                                                                    );
                                                                }
                                                            )}
                                                        </TeacherResultsContainerBox>
                                                    )}

                                                    <Box>
                                                        {!quickBookComplete && (
                                                            <Alert severity="success">
                                                                Teacher Search
                                                                Complete!
                                                            </Alert>
                                                        )}
                                                    </Box>
                                                    {state.apiState !== 0 &&
                                                        state.apiState !==
                                                            200 &&
                                                        sendNotification(
                                                            'error',
                                                            0,
                                                            'Error performing teacher search'
                                                        )}
                                                </AvailableTeachersBox>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Box>
                            </Box>
                        ) : (
                            <Loading sx={{ width: '100%' }} />
                        )}
                    </Route>

                    <Route
                        path="/book-teacher/availability/:id"
                        children={
                            <CreateBooking
                                avail={state.availability}
                                teacher={schoolInfo}
                                resetSearch={resetSearch}
                                removeItem={removeAvail}
                                searchAvail={setSearchDate}
                            />
                        }
                    ></Route>
                </Grid>
                <div />
            </div>
        );
    }

    return <div>{content}</div>;
};

export default withAuthenticationRequired(BookTeacherComponent, {
    onRedirecting: () => <Loading />,
});
